/* Supplemental product UX events. Shopify owns all standard ecommerce events. */
(function (scope) {
  'use strict';
  const products = ['bright-start', 'stay-soft', 'sun-kissed', 'face-mist', 'glow-hour', 'daily-three', 'seoul-root-full-routine'];
  const names = ['sr_image_view', 'sr_product_select', 'sr_detail_open', 'sr_education_interaction', 'sr_routine_select', 'sr_formula_select', 'sr_checkout_blocked', 'sr_cart_error', 'sr_journey_select', 'sr_guide_complete', 'sr_section_view', 'sr_card_view', 'sr_cta_click', 'sr_builder_change', 'sr_cart_attempt', 'sr_cart_success', 'sr_checkout_click', 'sr_tracking_ready'];
  const placements = ['hero', 'header', 'mobile_menu', 'home_shelf', 'shop_grid', 'routine', 'product', 'footer', 'cart', 'content'];
  function productFromPath(path) { return products.find(p => path.replace(/\/$/, '').endsWith('/products/' + p)); }
  const clean = value => typeof value === 'string' && /^[a-z0-9_-]{1,64}$/.test(value) ? value : undefined;
  function payload(name, data, path) {
    if (!names.includes(name)) return null;
    const result = { send_to: 'G-HL86C47CRW', sr_context: path === '/' ? 'home' : path.includes('/products/') ? 'product' : path.includes('/collections/') ? 'shop' : path === '/cart' ? 'cart' : path.split('/').filter(Boolean).pop() || 'other' };
    result.sr_context = clean(result.sr_context) || 'other';
    if (products.includes(data.sr_product)) result.sr_product = data.sr_product;
    if (clean(data.sr_detail)) result.sr_detail = data.sr_detail;
    if (placements.includes(data.sr_placement)) result.sr_placement = data.sr_placement;
    if (Number.isSafeInteger(data.sr_item_count) && data.sr_item_count >= 0 && data.sr_item_count <= 999) result.sr_item_count = data.sr_item_count;
    return result;
  }
  const queue = [];
  let retryTimer;
  function permitted() { try { return !scope.Shopify?.designMode && scope.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; } }
  function deliver(name, params) {
    if (typeof scope.gtag === 'function') { scope.gtag('event', name, params); return true; }
    if (Array.isArray(scope.dataLayer) && scope.document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      (function () { scope.dataLayer.push(arguments); })('event', name, params); return true;
    }
    return false;
  }
  function flush() {
    retryTimer = undefined;
    try {
      if (!permitted()) { queue.length = 0; return; }
      while (queue.length) {
        const event = queue[0];
        if (Date.now() - event.at > 5000) { queue.shift(); continue; }
        if (!deliver(event.name, event.params)) break;
        queue.shift();
      }
      if (queue.length) retryTimer = scope.setTimeout(flush, 250);
    } catch (_) { queue.length = 0; }
  }
  function send(name, data = {}) {
    try {
      if (!permitted()) return false;
      const params = payload(name, data, scope.location.pathname);
      if (!params) return false;
      // Reuse the channel's configured tag; never initialize a second tracker.
      if (!deliver(name, params)) {
        // Only events already permitted at capture time may wait briefly for the tag.
        if (typeof scope.setTimeout !== 'function' || queue.length >= 20) return false;
        queue.push({name, params, at: Date.now()});
        if (!retryTimer) retryTimer = scope.setTimeout(flush, 250);
      }
      return true;
    } catch (_) { return false; } // Analytics must never interrupt shopping.
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { payload, send, productFromPath };
  if (!scope.document || scope.SeoulRootAnalytics) return;
  function placement(el) {
    if (el.closest('.sr-mobile-nav')) return 'mobile_menu';
    if (el.closest('[data-sr-header]')) return 'header';
    if (el.closest('footer')) return 'footer';
    if (el.closest('.sr-home-intro')) return 'hero';
    if (el.closest('.sr-home-shop')) return 'home_shelf';
    if (el.closest('[data-sr-routine],.sr-choice,.sr-combo-invitation')) return 'routine';
    if (el.closest('[data-sr-product-page]')) return 'product';
    if (el.closest('[data-sr-cart-form]')) return 'cart';
    if (el.closest('.sr-shop-card')) return 'shop_grid';
    return 'content';
  }
  function context(el) {
    return {sr_product: el.closest('[data-sr-product]')?.dataset.srProduct || productFromPath(scope.location.pathname), sr_placement: placement(el)};
  }
  scope.SeoulRootAnalytics = { send, context };
  // Some storefronts do not load this API until explicitly requested.
  // Loading it reads Shopify's existing consent decision; it never grants consent.
  function loadPrivacy() {
    if (!scope.Shopify?.customerPrivacy && typeof scope.Shopify?.loadFeatures === 'function') {
      try { scope.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => scheduleVisible()); } catch (_) { /* Shopping remains available if the privacy API cannot load. */ }
    }
  }
  const doc = scope.document;
  const product = () => productFromPath(scope.location.pathname);
  const seen = new WeakSet();
  doc.addEventListener('click', event => {
    if (!(event.target instanceof scope.Element)) return;
    const el = event.target.closest('a,button');
    if (!el) return;
    if (el.matches('a[href]')) {
      const url = new URL(el.href, scope.location.origin);
      const handle = productFromPath(url.pathname);
      if (url.origin === scope.location.origin && handle) send('sr_product_select', { sr_product: handle, sr_detail: placement(el), sr_placement: placement(el) });
      if (url.origin === scope.location.origin && el.dataset.srCta) send('sr_cta_click', {...context(el), sr_detail: el.dataset.srCta});
    }
    if (el.hasAttribute('data-shelf-mode')) send('sr_routine_select', { sr_detail: el.dataset.shelfMode });
    if (el.hasAttribute('data-formula-choice')) send('sr_formula_select', { sr_product: el.dataset.formulaChoice });
    if (el.hasAttribute('data-layer')) send('sr_education_interaction', { sr_detail: 'layer_' + el.dataset.layer });
    if (el.hasAttribute('data-barrier')) send('sr_education_interaction', { sr_detail: 'barrier_' + el.dataset.barrier });
    if (el.matches('.sw-timeline a,.wy-nav a')) send('sr_education_interaction', { sr_detail: el.hash.slice(1) });
  });
  doc.addEventListener('toggle', event => {
    const el = event.target;
    if (!el.matches?.('details') || !el.open || seen.has(el)) return;
    if (product() && el.dataset.srDetail && send('sr_detail_open', { sr_product: product(), sr_detail: el.dataset.srDetail, sr_placement: 'product' })) seen.add(el);
  }, true);
  doc.addEventListener('change', event => {
    const el = event.target;
    if (!el.matches?.('[data-sr-builder-item]')) return;
    const owner = el.closest('[data-sr-routine]');
    if (owner) send('sr_builder_change', {...context(el), sr_detail: el.checked ? 'select' : 'deselect', sr_item_count: owner.querySelectorAll('[data-sr-builder-item]:checked:not(:disabled)').length});
  });
  // Exposures require at least half the target to be visible for one continuous second.
  // The shelf target is its heading, not the entire tall product grid.
  const exposures = new Map();
  let ready = false;
  function scheduleVisible() {
    if (doc.visibilityState === 'hidden') return;
    if (!ready) ready = send('sr_tracking_ready', {sr_detail: 'v2'});
    exposures.forEach((state, el) => {
      if (!state.visible || state.sent || state.timer || !permitted()) return;
      state.timer = scope.setTimeout(() => {
        state.timer = undefined;
        if (!state.visible || doc.visibilityState === 'hidden') return;
        state.sent = send(el.dataset.srObserve === 'product_card' ? 'sr_card_view' : 'sr_section_view', {...context(el), sr_detail: el.dataset.srObserve});
      }, 1000);
    });
  }
  if (scope.IntersectionObserver) {
    const observer = new scope.IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = exposures.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (!state.visible && state.timer) { scope.clearTimeout(state.timer); state.timer = undefined; }
      });
      scheduleVisible();
    }, {threshold: [0, 0.5]});
    doc.querySelectorAll('[data-sr-observe]').forEach(el => { exposures.set(el, {visible: false, sent: false}); observer.observe(el); });
  }
  doc.addEventListener('visibilitychange', () => {
    if (doc.visibilityState === 'hidden') exposures.forEach(state => { if (state.timer) scope.clearTimeout(state.timer); state.timer = undefined; });
    else scheduleVisible();
  });
  doc.addEventListener('visitorConsentCollected', () => {
    if (!permitted()) { queue.length = 0; exposures.forEach(state => { if (state.timer) scope.clearTimeout(state.timer); state.timer = undefined; }); }
    else scheduleVisible();
  });
  loadPrivacy();
  scheduleVisible();
  scope.addEventListener?.('load', () => { loadPrivacy(); scheduleVisible(); }, {once: true});
  scope.addEventListener?.('pagehide', () => {
    flush(); queue.length = 0;
    if (retryTimer) scope.clearTimeout(retryTimer);
    exposures.forEach(state => { if (state.timer) scope.clearTimeout(state.timer); });
  }, {once: true});
})(typeof window === 'undefined' ? {} : window);
